module.exports = __webpack_public_path__ + "static/media/Farmak_kab_gif.1872a627.gif";